import { useEffect, useMemo, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { uniqWith } from 'lodash';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';

import { employeeAutocompleteForMentionWithLimit } from 'services/search';

const useMatchedEmployees = ({ selectedEmployees = [], searchText = '' }) => {
  const [matchedEmployees, setMatchedEmployees] = useState([]);
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);

  const { data } = useQuery(['useMatchedEmployees', searchText], () =>
    // @ts-ignore
    employeeAutocompleteForMentionWithLimit({
      query: searchText,
      limit: 5,
    })
  );

  const fetchedEmployees = useMemo(
    () =>
      searchText === ''
        ? []
        : data
            ?.map(({ employee, companyId, companyName }) => ({
              id: employee.id,
              displayName: employee.displayName,
              profilePhoto: employee.profilePhotoSrc,
              email: employee.email,
              isSelected: false,
              companyId,
              companyName,
            }))
            .filter((emp) => emp.id !== loggedInEmployeeId),
    [data, searchText]
  );

  useEffect(() => {
    const filteredSelectedEmployees = selectedEmployees.filter(
      ({ displayName = '', email = '' }) =>
        displayName.toLowerCase().includes(searchText.toLowerCase()) ||
        email.toLowerCase().includes(searchText.toLowerCase())
    );
    const uniqueMatchedEmployees = uniqWith(
      // @ts-ignore
      [...filteredSelectedEmployees, ...(fetchedEmployees ?? [])],
      (a, b) => String(a.id) === String(b.id)
    );
    setMatchedEmployees(uniqueMatchedEmployees);
    console.log('beingcalled');
  }, [selectedEmployees, fetchedEmployees, searchText]);

  return matchedEmployees;
};

export default useMatchedEmployees;
